import type { RegistryEntry } from "../../shared.ts";
import { CHAT_OPENAI_COMPAT_MODELS } from "../../shared.ts";

export const llamagateProvider: RegistryEntry = {
  id: "llamagate",
  alias: "llamagate",
  format: "openai",
  executor: "default",
  baseUrl: "https://llamagate.ai/v1/chat/completions",
  authType: "apikey",
  authHeader: "bearer",
  models: CHAT_OPENAI_COMPAT_MODELS.llamagate,
};
